export interface UserDataChangesModel {
  actionAcceptor: string;
  actionInitiator: string;
  actionTimestamp: number;
  actionType: string;
  valueAfter: string;
}
